/**
 * MyAccountTab.
 *
 * Sections:
 *   1. Email + name display
 *   2. PasswordChangeForm — change password; redirects to /login on success
 *   3. PersonalAuditLog — GET /api/audit-events/me paginated
 *
 * Active sessions list removed per operator request — sessions can still be
 * revoked from the auth API (/api/auth/sessions, /api/auth/sessions/:id) for
 * admin/incident response use.
 */
import { Divider, Stack, Text, Title } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../state/auth-store';
import PasswordChangeForm from './PasswordChangeForm';
import PersonalAuditLog from './PersonalAuditLog';

export default function MyAccountTab() {
  const user = useAuthStore((s) => s.user);
  const navigate = useNavigate();

  if (!user) {
    return null;
  }

  function handlePasswordChanged() {
    navigate('/login', { replace: true });
  }

  return (
    <Stack gap="xl" data-testid="my-account-tab">
      <Stack gap="xs">
        <Title order={4}>My account</Title>
        <Text size="sm">
          <strong>Email:</strong> <span data-testid="account-email">{user.email}</span>
        </Text>
        <Text size="sm">
          <strong>Name:</strong> <span data-testid="account-name">{user.name}</span>
        </Text>
      </Stack>

      <Divider />

      <PasswordChangeForm onSuccess={handlePasswordChanged} />

      <Divider />

      <PersonalAuditLog />
    </Stack>
  );
}
